import { createTypographyComponent } from "./helpers";

const H4 = createTypographyComponent("h4", "scroll-m-20 text-xl font-semibold tracking-tight");

export default H4;
